export type DropDownUserMenuProps = {
  userName: string;
  userMail?: string; // CAMBIO: Opcional para operarios
  userRole: string;
  onClose?: () => void; // Callback para cerrar el menú cuando se abre un modal
};

export const Roles: { [key: string]: string } = {
  'super-admin': 'Super Admin',
  coex: 'Super COEX',
  capataz: 'Capataz',
  'room-team': 'Operador de sala',
  tablet: 'Usuari de Tablet',
  'operating-team': 'Operari de carretera',
};
